import './App.css';
import './css/style.css';
import './charts/ChartjsConfig';
import AuthProvider from "./providers/AuthProvider";
import Routes from "./routes";
import { NotificationProvider } from './contexts/NotificationContext';

function App() {
  return (
      <AuthProvider>
        <NotificationProvider>
          <Routes />
        </NotificationProvider>
      </AuthProvider>
  );
}

export default App;
